/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ExposureInputs */

const en_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposure`)
};

const ar_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعريض`)
};

const bn_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সপোজার`)
};

const de_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belichtung`)
};

const es_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposición`)
};

const fr_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposition`)
};

const pt_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposição`)
};

const zh_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曝光`)
};

const tr_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozlama`)
};

const ru_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспозиция`)
};

const pl_image_inspector_exposure = /** @type {(inputs: Image_Inspector_ExposureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspozycja`)
};

/**
* | output |
* | --- |
* | "Exposure" |
*
* @param {Image_Inspector_ExposureInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_exposure = /** @type {((inputs?: Image_Inspector_ExposureInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ExposureInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_exposure(inputs)
	if (locale === "bn") return bn_image_inspector_exposure(inputs)
	if (locale === "de") return de_image_inspector_exposure(inputs)
	if (locale === "es") return es_image_inspector_exposure(inputs)
	if (locale === "fr") return fr_image_inspector_exposure(inputs)
	if (locale === "pt") return pt_image_inspector_exposure(inputs)
	if (locale === "zh") return zh_image_inspector_exposure(inputs)
	if (locale === "tr") return tr_image_inspector_exposure(inputs)
	if (locale === "ru") return ru_image_inspector_exposure(inputs)
	if (locale === "pl") return pl_image_inspector_exposure(inputs)
	return en_image_inspector_exposure(inputs)
});